import { isTrue, isEmpty } from "./helpers";
import { DataType } from "./types";

//** Find Default Value object fromValidation Rule */
const getDefaultValue = validationRule => {
  const defaultValue = Object.keys(validationRule)
    .filter(key => !isEmpty(validationRule[key]?.defaultValue))
    .reduce(
      (acc, key) => ({
        ...acc,
        [key]:
          validationRule[key]?.dataType === DataType.SELECT && isTrue(validationRule[key]?.multiple)
            ? validationRule[key].defaultValue?.split(",").map(e => e.trim()) || []
            : validationRule[key].defaultValue
      }),
      {}
    );

  return defaultValue;
};

export default getDefaultValue;
